import * as React from 'react';
import loadable from '@loadable/component';
import { Helmet } from 'react-helmet-async';
import withMicroFrontendProps from 'Common/Microfrontend';
import useTranslator from 'Client/hooks/useTranslator';
import { useBellaSelector } from 'Client/redux/hooks';

const Cart = loadable(() => import('mf-cart/Main'), { ssr: false });

const CartWithBellaProps = withMicroFrontendProps(Cart, 'mf-cart');

const CartMicroFrontend = () => {
    const t = useTranslator();
    const configurations = useBellaSelector(({ configurations }) => configurations);

    return (
        <div>
            <Helmet>
                <title>
                    {t('Ihr Warenkorb im Überblick')} | {t('SHOP_NAME')}
                </title>
            </Helmet>
            <CartWithBellaProps configurations={configurations} />
        </div>
    );
};

export default CartMicroFrontend;
